// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// TODO: this should come from a simple view from the server
// or just figure it out from the domain
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDqPREcS7polVxFtaFLwcbwd2vbrhbrEF0", // public OK
//   authDomain: "epl-helios-dev.firebaseapp.com",
//   projectId: "epl-helios-dev",
//   storageBucket: "epl-helios-dev.appspot.com",
//   messagingSenderId: "745919149919",
//   appId: "1:745919149919:web:7b1b9336bbfb2d8aca68ea"
// };

const continueURL = process.env.ACTION_CONTINUE_URL

const appCheckConfig = { reCaptchaEnterpriseSiteKey: process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY, }

export { firebaseConfig, appCheckConfig, continueURL };
